"use client";

import { c as _c } from "react/compiler-runtime";
import InteractiveIcon from "@/components/drops/media/InteractiveIcon";
import { Children, type ReactNode } from "react";
interface InteractiveMediaLoadGateProps {
  readonly onLoad: () => void;
  readonly children?: ReactNode;
  readonly ariaLabel?: string | undefined;
  readonly className?: string | undefined;
  readonly buttonLabel?: string | undefined;
}
export default function InteractiveMediaLoadGate(t0) {
  const $ = _c(18);
  const {
    onLoad,
    children,
    ariaLabel: t1,
    className,
    buttonLabel: t2
  } = t0;
  const ariaLabel = t1 === undefined ? "Load interactive media" : t1;
  const buttonLabel = t2 === undefined ? "Tap to load" : t2;
  let t3;
  if ($[0] !== children) {
    t3 = Children.toArray(children);
    $[0] = children;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const hasBackground = t3.length > 0;
  let t4;
  if ($[2] !== className) {
    t4 = ["tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center", className].filter(_temp);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const wrapperClassName = t4.join(" ");
  let t5;
  if ($[4] !== children || $[5] !== hasBackground) {
    t5 = hasBackground ? <><div className="tw-h-full tw-w-full">{children}</div><div aria-hidden="true" className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-iron-950/20" /></> : <div aria-hidden="true" className="tw-absolute tw-inset-0 tw-bg-iron-950/30" />;
    $[4] = children;
    $[5] = hasBackground;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <InteractiveIcon className="tw-size-4 tw-flex-shrink-0" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== buttonLabel) {
    t7 = <span className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border tw-border-white/20 tw-bg-iron-950/90 tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-shadow-[0_16px_40px_rgba(0,0,0,0.65)] tw-ring-1 tw-ring-white/10 tw-transition hover:tw-bg-iron-900">{t6}{buttonLabel}</span>;
    $[8] = buttonLabel;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== ariaLabel || $[11] !== onLoad || $[12] !== t7) {
    t8 = <button type="button" onClick={onLoad} className="tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-transparent" aria-label={ariaLabel}>{t7}</button>;
    $[10] = ariaLabel;
    $[11] = onLoad;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8 || $[16] !== wrapperClassName) {
    t9 = <div className={wrapperClassName}>{t5}{t8}</div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = wrapperClassName;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp(value) {
  return Boolean(value);
}